import React from 'react';
import { Input, inputStyleClasses } from 'Components/Input';
import RowsSelector from 'Components/RowsSelector';

export default ({ outCount, handleRowCountSelect, rowsCount, searchString, handleSearchStringInput }) => {
  return (
    <React.Fragment>
      <section className='list-scene__utility-section-wrapper'>
        <section className='list-scene__utility-section-filters-wrapper'>
          <Input
            mainWrapperClassName='list-scene__header-search-field-wrapper'
            styleClass={inputStyleClasses.searchBar}
            placeholder='Type here to search'
            maxLength={250}
            value={searchString}
            onChange={handleSearchStringInput}
          />
        </section>
        <div className='list-scene__utility-section-rows-select-wrapper'>
          <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowCountSelect} selectedRowsCount={rowsCount} />
        </div>
      </section>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/InspectorDashboardScene/Header.jsx